<template>
  <div class="layout-menu-card-header">
    <div class="header-content-left">
      <div class="header-title">常用模块</div>
      <UserAccess
        ref="userAccess"
        v-if="showUserAccess"
        :isShowComment="false"
      />
    </div>
    <div class="header-content-right">
      <div class="fr" type="text" @click="showMenuDialog">
        <span class="fr-plus"></span>
        <span>添加常用</span>
      </div>
      <div class="fr" type="text" @click="showGroupDialog">
        <span class="fr-group" />
        <span>分组管理</span>
      </div>
    </div>
  </div>
</template>

<script>
  // 用户评价
  import UserAccess from '@/public/components/query-table/user-access'
  export default {
    data() {
      return {
        showUserAccess: false
      }
    },
    components: { UserAccess },
    mounted () {
      this.$bus.$once('APP_LOADED', this.init)
      if (window.__APP_LOADED__ === true) {
        this.showUserAccess = true
      }
    },
    methods: {
      init () {
        this.showUserAccess = true
      },
      showMenuDialog () {
        this.$emit('showMenuDialog')
      },
      showGroupDialog () {
        this.$emit('showGroupDialog')
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-menu-card-header {
  margin-bottom: 0px;
  height: 36px;
  line-height: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1;
  .header-content-left {
    display: flex;
    align-items: center;
    .header-title {
      font-size: 16px;
      color: #1d1c23;
      font-weight: bolder;
    }
  }
  .header-content-right {
    display: flex;
    align-items: center;
    gap: 8px;
    .fr {
      height: 26px;
      padding: 0 12px;
      width: fit-content;
      border: 0.5px solid #E0DFEF;
      border-radius: 12px;
      background: rgba(255, 255, 255, 1);
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 4px;
      color: #1d1c23;
      .fr-plus {
        display: block;
        background-image: url('../images/plus.png');
        background-size: contain;
        width: 12px;
        height: 12px;
      }
      .fr-group {
        display: block;
        background-image: url('../images/group.png');
        background-size: contain;
        width: 12px;
        height: 12px;
      }
      &:hover {
        color: #6d2ef8;
        background: rgba(109, 46, 248, 0.07);
        .fr-plus {
          background-image: url('../images/plus-hover.png');
        }
        .fr-group {
          background-image: url('../images/group-hover.png');

        }
      }
      span{

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/card-header.vue